import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Container from "@material-ui/core/Container";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import {useRouter} from "next/router";
import {createStyles, makeStyles} from "@material-ui/core/styles";
import Link from "next/link";
import {FormattedMessage} from "react-intl";

const useStyles = makeStyles((theme) => createStyles({
    navAppBar: {
        background: 'transparent',
        boxShadow: 'none',
    },
    navLogo: {
        [theme.breakpoints.only('xs')]: {
            width: 50,
        },
        display: "block",
        maxHeight: "100%",
        width: 80
    },
    navContainerLeft: {
        flexGrow: 1,
        textAlign: 'right',
        alignSelf: 'center',
        width: '20%',
    },
    navContainerLogo: {
        margin: theme.spacing(1, 4),
        [theme.breakpoints.down('sm')]: {
            margin: theme.spacing(1),
        },
    },
    navContainerRight: {
        flexGrow: 1,
        textAlign: 'left',
        alignSelf: 'center',
        width: '20%',
    },
    navFlagContainer: {
        position: 'absolute',
        bottom: -30,
        left: '50%',
        transform: 'translate(-50%, 0)',
    },
    navLink: {
        fontSize: '1.3rem',
        color: theme.palette.primary.main,
        textDecoration: 'none',
        margin: theme.spacing(0, 1),
        '&:hover': {
            color: theme.palette.text.primary,
            textDecoration: 'underline',
        }
    },
    navLinkActive: {
        color: theme.palette.text.primary,
        textDecoration: 'underline',
    },
    flexContainer: {
        display: 'flex',
        width: '100%',
    },
}));

function Nav() {
    const classes = useStyles();
    const router = useRouter();
    const logo = require('../images/logo-orange_original.png?sizes[]=80&sizes[]=50');

    return (
        <AppBar position="absolute" classes={{root: classes.navAppBar}}>
            <Container maxWidth="lg">
                <Toolbar disableGutters>
                    <div className={classes.flexContainer}>
                        <div className={classes.navContainerLeft}>
                            <Link href={"/"}>
                                <a className={clsx(classes.navLink, {
                                    [classes.navLinkActive]: router.route === '/',
                                })}>
                                    <FontAwesomeIcon fixedWidth={true} icon={["far", "home-alt"]} />
                                    <FormattedMessage id="home"/>
                                </a>
                            </Link>
                        </div>
                        <div className={classes.navContainerLogo}>
                            <Link href={"/"}>
                                <img className={classes.navLogo} src={logo.src} srcSet={logo.srcSet} alt={"Logo"} />
                            </Link>
                        </div>
                        <div className={classes.navContainerRight}>
                            <Link href={"/careers"}>
                                <a className={clsx(classes.navLink, {
                                    [classes.navLinkActive]: router.route === '/careers',
                                })}>
                                    <FontAwesomeIcon fixedWidth={true} icon={["far", "user-hard-hat"]} />
                                    <FormattedMessage id="jobs"/>
                                </a>
                            </Link>
                        </div>
                    </div>
                    <div className={classes.navFlagContainer}>
                        {router.locales.map(lang => (
                            <Link key={lang} href={router.route} as={router.asPath} locale={lang}>
                                <a hrefLang={lang} className={clsx(classes.navLink, {
                                    [classes.navLinkActive]: router.locale === lang,
                            })}>{lang.toUpperCase()}</a>
                            </Link>
                        ))}
                    </div>
                </Toolbar>
            </Container>
        </AppBar>
    );
}
export default Nav;
